import { motion } from "framer-motion";
import Reveal from "@/components/Reveal";
import { fadeUp, viewport, stagger } from "@/lib/motion";

const STEPS = [
  { n: "01", title: "Take the free 2-minute digital liver assessment", },
  { n: "02", title: "Receive your color risk category" },
  { n: "03", title: "Get a recommended next step based on your risk" },
  { n: "04", title: "Undergo a Precision Liver Evaluation" },
  { n: "05", title: "Enroll in our signature 12-week personalized recovery plan" },
  { n: "06", title: "Begin Long-Term Monitoring to measure, improve, and sustain liver health" },
];

export const LiverJourney = () => {
  return (
    <section id="journey" className="bg-sa-beige py-12 md:py-16" data-testid="journey-section">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <Reveal className="max-w-3xl">
          <p className="mb-4 text-[13px] font-semibold uppercase tracking-[0.2em] text-sa-copper">
            Your liver journey
          </p>
          <h2 className="font-display text-4xl font-medium leading-[1.08] tracking-tight text-sa-forest sm:text-5xl">
            Six clear steps, start to sustained.
          </h2>
        </Reveal>

        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="show"
          viewport={viewport}
          className="mt-10 grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3"
        >
          {STEPS.map((s) => (
            <motion.div
              key={s.n}
              variants={fadeUp}
              className="group relative flex flex-col justify-between overflow-hidden rounded-[28px] border border-white bg-white p-8 transition-transform duration-300 hover:-translate-y-1"
            >
              <span className="pointer-events-none absolute -right-3 -top-6 select-none font-display text-[6rem] font-bold leading-none text-sa-beige">
                {s.n}
              </span>
              <div className="relative">
                <span className="font-serif text-xl italic text-sa-copper">Step {parseInt(s.n)}</span>
                <p className="mt-4 font-display text-xl font-medium leading-snug text-sa-forest">
                  {s.title}
                </p>
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default LiverJourney;
